import {Injectable, signal} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AppConfig} from '../../app.config';

export interface Task {
  id: number;
  title: string;
  description?: string;
  deadline?: string | null;
  taskGroupId: number;
  taskGroup?: TaskGroup;
  certificateAllowed?: boolean;
  certificateTemplateId?: number | null;
  countryId?: number;
  cityId?: number;
  organizationId?: number;
}

export interface TaskDocument {
  id: number;
  name: string;
  publicAccess?: boolean;
}

export interface TaskGroup {
  id: number;
  title: string;
  countryId?: number;
  cityId?: number;
  organizationId?: number;
  task?: Task[];
}

@Injectable()
export class TaskGroupService {
  taskEnabled = signal(false);
  constructor(private http: HttpClient, private api: AppConfig) {}

  addTaskGroup(data: Partial<TaskGroup>) {
    return this.http.post<TaskGroup>(this.api.baseUrl + '/taskGroup/addTaskGroup', data, this.api.jsonTokenHeaders);
  }

  getTaskGroup(search = '') {
    return this.http.get<TaskGroup[]>(this.api.baseUrl + '/taskGroup/getTaskGroup?search=' + encodeURIComponent(search), this.api.jsonTokenHeaders);
  }

  getTaskGroupEmpty() {
    return this.http.get<TaskGroup[]>(this.api.baseUrl + '/taskGroup/getTaskGroupEmpty', this.api.jsonTokenHeaders);
  }

  deleteTaskGroup(id: number) {
    return this.http.get(this.api.baseUrl + '/taskGroup/deleteTaskGroup?id=' + id, this.api.jsonTokenHeaders);
  }

  addTask(data: Partial<Task>) {
    return this.http.post<Task>(this.api.baseUrl + '/task/addTask', data, this.api.jsonTokenHeaders);
  }

  getTask(organizationId = '') {
    return this.http.get<Task[]>(this.api.baseUrl + '/task/getTask?organizationId=' + organizationId, this.api.jsonTokenHeaders);
  }

  getTaskById(id: number) {
    return this.http.get<Task & {documents: TaskDocument[]}>(this.api.baseUrl + '/task/getTaskById?id=' + id, this.api.jsonTokenHeaders);
  }

  deleteTask(id: number) {
    return this.http.get(this.api.baseUrl + '/task/deleteTask?id=' + id, this.api.jsonTokenHeaders);
  }
}
